import { render, staticRenderFns } from "./ProductSaleInfo.vue?vue&type=template&id=1d5129fd&scoped=true"
import script from "./ProductSaleInfo.vue?vue&type=script&lang=js"
export * from "./ProductSaleInfo.vue?vue&type=script&lang=js"
import style0 from "./ProductSaleInfo.vue?vue&type=style&index=0&id=1d5129fd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d5129fd",
  null
  
)

export default component.exports